// import { useState } from "react";
// import EventCard from "../../components/EventCard";
// import Select from "../../components/Select";
// import { useData } from "../../contexts/DataContext";
// import Modal from "../Modal";
// import ModalEvent from "../ModalEvent";

// import "./style.css";

// const PER_PAGE = 9;

// const EventList = () => {
//   const { data, error } = useData();
//   const [type, setType] = useState();
//   const [currentPage, setCurrentPage] = useState(1);
//   const filteredEvents = (
//     (!type
//       ? data?.events
//       : data?.events) || []
//   ).filter((event, index) => {
//     if (
//       (currentPage - 1) * PER_PAGE <= index &&
//       PER_PAGE * currentPage > index
//     ) {
//       return true;
//     }
//     return false;
//   });
//   const changeType = (evtType) => {
//     setCurrentPage(1);
//     setType(evtType);
//   };
//   const pageNumber = Math.floor((filteredEvents?.length || 0) / PER_PAGE) + 1;
//   const typeList = new Set(data?.events.map((event) => event.type));
//   return (
//     <>
//       {error && <div>An error occured</div>}
//       {data === null ? (
//         "loading"
//       ) : (
//         <>
//           <h3 className="SelectTitle">Catégories</h3>
//           <Select
//             selection={Array.from(typeList)}
//             onChange={(value) => (value ? changeType(value) : changeType(null))}
//           />
//           <div id="events" className="ListContainer">
//             {filteredEvents.map((event) => (
//               <Modal key={event.id} Content={<ModalEvent event={event} />}>
//                 {({ setIsOpened }) => (
//                   <EventCard
//                     onClick={() => setIsOpened(true)}
//                     imageSrc={event.cover}
//                     title={event.title}
//                     date={new Date(event.date)}
//                     label={event.type}
//                   />
//                 )}
//               </Modal>
//             ))}
//           </div>
//           <div className="Pagination">
//             {[...Array(pageNumber || 0)].map((_, n) => (
//               // eslint-disable-next-line react/no-array-index-key
//               <a key={n} href="#events" onClick={() => setCurrentPage(n + 1)}>
//                 {n + 1}
//               </a>
//             ))}
//           </div>
//         </>
//       )}
//     </>
//   );
// };

// export default EventList;
import { useState, useMemo } from "react";
import EventCard from "../../components/EventCard";
import Select from "../../components/Select";
import { useData } from "../../contexts/DataContext";
import Modal from "../Modal";
import ModalEvent from "../ModalEvent";

import "./style.css";

const PER_PAGE = 9;

/**
 * EventList
 *  - Affiche la liste des évènements
 *  - Possibilité de filtrer par catégorie (type)
 *  - Pagination côté client
 */
const EventList = () => {
  const { data, error } = useData();

  /**
   * Type sélectionné dans le filtre.
   * null (ou undefined) → aucun filtre, on affiche tout.
   */
  const [selectedType, setSelectedType] = useState(null);

  /**
   * Page courante (1‑based).
   */
  const [currentPage, setCurrentPage] = useState(1);

  /**
   * Ensemble distinct des types pour alimenter le composant Select.
   * Utilise Set pour dédupliquer puis Array.from pour obtenir un tableau.
   */
  const typeList = useMemo(
    () => Array.from(new Set(data?.events?.map((event) => event.type) || [])),
    [data]
  );

  /**
   * Liste filtrée selon le type sélectionné.
   */
  const eventsFilteredByType = useMemo(() => {
    if (!data?.events) return [];
    return selectedType
      ? data.events.filter((e) => e.type === selectedType)
      : data.events;
  }, [data, selectedType]);

  /**
   * Pagination – on découpe la liste filtrée par tranche de PER_PAGE.
   */
  const paginatedEvents = useMemo(() => {
    const start = (currentPage - 1) * PER_PAGE;
    const end = currentPage * PER_PAGE;
    return eventsFilteredByType.slice(start, end);
  }, [eventsFilteredByType, currentPage]);

  /**
   * Nombre total de pages après filtrage.
   */
  const pageNumber = Math.ceil(eventsFilteredByType.length / PER_PAGE);

  /**
   * Gestion du changement de catégorie sélectionnée.
   */
  const handleTypeChange = (evtType) => {
    // Réinitialise la pagination à la première page
    setCurrentPage(1);
    setSelectedType(evtType || null);
  };

  if (error) return <div>An error occurred</div>;
  if (!data) return <div>Loading…</div>;

  return (
    <>
      <h3 className="SelectTitle">Catégories</h3>
      <Select selection={typeList} onChange={handleTypeChange} />

      <div id="events" className="ListContainer">
        {paginatedEvents.map((event) => (
          <Modal key={event.id} Content={<ModalEvent event={event} />}>
            {({ setIsOpened }) => (
              <EventCard
                onClick={() => setIsOpened(true)}
                imageSrc={event.cover}
                title={event.title}
                date={new Date(event.date)}
                label={event.type}
              />
            )}
          </Modal>
        ))}
      </div>

      {/* Pagination */}
      {pageNumber > 1 && (
        <div className="Pagination">
          {[...Array(pageNumber)].map((_, n) => (
            // eslint-disable-next-line react/no-array-index-key
            <a key={n} href="#events" onClick={() => setCurrentPage(n + 1)}>
              {n + 1}
            </a>
          ))}
        </div>
      )}
    </>
  );
};

export default EventList;
